/**
 * The `imageType` query parameter of search-exclusive-new.php.
 *
 * The search sidebar's "Image Type" filter puts its choice in the page URL as
 * `type` (photo | vector | illustration). The search service wants a code
 * instead:
 *
 *   vector        8
 *   illustration  2
 *   photo         null   (no image-type restriction)
 *   nothing       null
 *
 * One place for the mapping, because three callers build that URL by hand:
 * ApiService.fetchData, ApiService.searchStockImages and BudgetService.getImages.
 */
export const IMAGE_TYPE_NONE = 'null';

const IMAGE_TYPE_CODES: { [slug: string]: string } = {
    vector: '8',
    illustration: '2'
};

/**
 * The code for a sidebar `type` value. Tolerates what a query parameter can
 * arrive as — undefined, a string, a comma list or an array — and reads the
 * first entry, since the filter allows one type at a time.
 */
export function imageTypeCode(type: any): string {
    const first = Array.isArray(type) ? type[0] : String(type || '').split(',')[0];
    const slug = String(first || '').trim().toLowerCase();

    return IMAGE_TYPE_CODES[slug] || IMAGE_TYPE_NONE;
}
